module.exports = "/assets/data/62611b656976460c988460e479c5e75e-GL19.data.json";